import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class TopElevenDeleted extends DomainEvent<DeletedEntity> {}
